var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-content",attrs:{"id":_vm.id}},[_c('iframe',{attrs:{"src":_vm.url,"allow":"fullscreen; clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }